import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import {
  customElement,
  property,
  queryAssignedElements,
} from 'lit/decorators.js';
import componentStyles from './idb-simple-columns.css.lit';
import { classMap } from 'lit/directives/class-map.js';
/**
 * The IdbSimpleColumns component
 * @element idb-simple-columns
 */
@customElement('idb-simple-columns')
export class IdbSimpleColumns extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @queryAssignedElements()
  slotted: Array<HTMLElement>;

  @property({ type: Boolean, attribute: 'mobile-center' })
  mobileCenter: boolean;

  render(): TemplateResult {
    const containerClasses = {
      'idb-simple-columns': true,
      'mobile-center': this.mobileCenter,
    };
    return html`
      <section class="${classMap(containerClasses)}">
        <slot>
        </slot>
      </section>
    `;
  }

  firstUpdated() {
    this.setCSSVars();
  }

  setCSSVars() {
    if (this.slotted.length > 0) {
      this.style.setProperty(
        '--columns',
        `repeat(${this.slotted.length}, minmax(0px, 1fr))`
      );
      this.style.setProperty('display', 'flex');
      this.style.setProperty('justify-content', 'center');
    }
  }
}
